<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Vertical Bar</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-bar-chart
                  :height="250"
                  :data="ChartOptions.verticalbarchart.data"
                  :options="ChartOptions.verticalbarchart.options"
                ></chartjs-bar-chart>
             </div>
        </div>
      </vs-col>
       <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Horizontal Bar</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-horizontal-bar-chart
                  :height="250"
                  :data="ChartOptions.horizontalbarchart.data"
                  :options="ChartOptions.horizontalbarchart.options"
                ></chartjs-horizontal-bar-chart>
             </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Multi axis Bar</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-bar-chart
                  :height="250"
                  :data="ChartOptions.multiaxisbarchart.data"
                  :options="ChartOptions.multiaxisbarchart.options"
                ></chartjs-bar-chart>
             </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Stacked Bar</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-bar-chart
                  :height="250"
                  :data="ChartOptions.stackedbarchart.data"
                  :options="ChartOptions.stackedbarchart.options"
                ></chartjs-bar-chart>
             </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import ChartjsBarChart from "../../components/chartjs/ChartjsBarChart.vue";
import ChartjsHorizontalBarChart from "../../components/chartjs/ChartjsHorizontalBarChart.vue";
import ChartJS from "@/demo-data/Chart/Chartjs.js";

export default {
  components: {
    ChartjsBarChart,
    ChartjsHorizontalBarChart
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
   ChartOptions: ChartJS[0],
    };
  },
};
</script>